// extracted by mini-css-extract-plugin
module.exports = {"comment":"_1kPCA6cjou6fQgZl3_0mLE","item":"_1JfSFfQWRegMUmdLlH-BDs","icon":"_3ru4BNhmW0VrMElrDD87Z9"};